export default __webpack_public_path__ + "static/media/banner1.30b088fc.png";